import { memo } from 'react';
import { useSelector } from '@bonanza-social/toolkit/state';
import { selectPrizeWallCampaignWinnersBackgroundImage } from '../../../state/prizeWallCampaign/prizeWallCampaign.slice';
import { PrizeWallWinnersBackgroundProps } from './PrizeWallWinnersBackground.types';
import PrizeWallImage from '../../common/PrizeWallImage/PrizeWallImage';

function PrizeWallWinnersBackground({
  contentFit = 'cover',
}: PrizeWallWinnersBackgroundProps) {
  const backgroundImage = useSelector(
    selectPrizeWallCampaignWinnersBackgroundImage,
  );

  return (
    <PrizeWallImage
      {...backgroundImage}
      contentFit={contentFit}
      position="absolute"
      inset={0}
    />
  );
}

export default memo(PrizeWallWinnersBackground);
